import {
  deleteBrandApi,
  deleteBrandLogoApi,
  deleteCompanyApi,
  deleteCompanyLogoApi,
  getAllBrandApi,
  getAllCompanyApi,
  getBrandApi,
  getCompanyApi,
  getSingleCompanyApi,
  postBrandApi,
  postBrandLogoApi,
  postCompanyApi,
  postCompanyLogoApi,
  updateBrandApi,
  updateBrandStatusApi,
  updateCompanyApi,
  updateCompanyShiprocketTagApi,
  updateCompanyStatusApi,
  verifyCompanyApi,
} from "../../api/common/CompanyAndBrandApi";
import { getAdminUserAPI } from "../../api/UserManagementApi";
import { saveToken } from "../../../token/token";
import { normalizeCompanyVerification } from '../../../utils/companyVerification';
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  company: {},
  singleCompany: {},
  companies: [],
  companiesTotal: -1,
  companiesRequestId: null,
  companyLogo: {},
  brandLogo: {},
  brands: [],
  brand: {},
  editBrand: {
    isEdit: false,
    body: {},
  },
  stepper: 0,
  logoLoading: false,
  loading: false,
  singleCompanyLoading: false,
  uploading: false,
  verifing: false,
  shiptagLoading: false,
};

export const getAllCompany = createAsyncThunk(
  "companyBrand/getAllCompany",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAllCompanyApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getCompany = createAsyncThunk(
  "companyBrand/getCompany",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getCompanyApi(payload);
      const userId = payload?.userId;
      if (userId) {
        getAdminUserAPI({ userId })
          .then((userDetailResponse) => {
            console.log("get-user-detail response", userDetailResponse);
          })
          .catch((userDetailError) => {
            console.log("get-user-detail error", userDetailError);
          });
      }
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getSingleCompany = createAsyncThunk(
  "companyBrand/getSingleCompany",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getSingleCompanyApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const postCompany = createAsyncThunk(
  "companyBrand/postCompany",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postCompanyApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateCompany = createAsyncThunk(
  "companyBrand/updateCompany",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateCompanyApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deleteCompany = createAsyncThunk(
  "companyBrand/deleteCompany",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteCompanyApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const postCompanyLogo = createAsyncThunk(
  "companyBrand/postCompanyLogo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postCompanyLogoApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deleteCompanyLogo = createAsyncThunk(
  "companyBrand/deleteCompanyLogo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteCompanyLogoApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getBrand = createAsyncThunk(
  "companyBrand/getBrand",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getBrandApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getAllBrands = createAsyncThunk(
  "companyBrand/getAllBrands",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAllBrandApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const postBrand = createAsyncThunk(
  "companyBrand/postBrand",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postBrandApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateBrand = createAsyncThunk(
  "companyBrand/updateBrand",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateBrandApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deleteBrand = createAsyncThunk(
  "companyBrand/deleteBrand",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteBrandApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const postBrandLogo = createAsyncThunk(
  "companyBrand/postBrandLogo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postBrandLogoApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deleteBrandLogo = createAsyncThunk(
  "companyBrand/deleteBrandLogo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteBrandLogoApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateCompanyStatus = createAsyncThunk(
  "companyBrand/updateCompanyStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateCompanyStatusApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const verifyCompany = createAsyncThunk(
  "companyBrand/verifyCompany",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await verifyCompanyApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateCompanyShiprocketTag = createAsyncThunk(
  "companyBrand/updateCompanyShiprocketTag",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateCompanyShiprocketTagApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateBrandStatus = createAsyncThunk(
  "companyBrand/updateBrandStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateBrandStatusApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

const companyAndBrandSlice = createSlice({
  name: "companyBrand",
  initialState,
  reducers: {
    setEditBrand: (state, action) => {
      state.editBrand = {
        isEdit: action.payload.isEdit,
        body: action.payload.body,
      };
    },
    setStepper: (state, action) => {
      state.stepper = action.payload;
    },
    setBrandNull: (state, action) => {
      state.brand = {};
    },
    setSingleCompanyNull: (state, action) => {
      state.singleCompany = {};
    },
  },
  extraReducers: (builder) => {
    // company

    // get all company
    builder.addCase(getAllCompany.pending, (state, action) => {
      state.companiesRequestId = action.meta.requestId;
      state.loading = true;
    });
    builder.addCase(getAllCompany.fulfilled, (state, action) => {
      if (state.companiesRequestId !== action.meta.requestId) return;
      const result = action?.payload?.response;
      state.companies = (Array.isArray(result) ? result : (result?.content ?? []))
        .map(normalizeCompanyVerification);
      state.companiesTotal = result?.totalElements ?? action?.payload?.totalElements ?? -1;
      state.loading = false;
    });
    builder.addCase(getAllCompany.rejected, (state, action) => {
      if (state.companiesRequestId !== action.meta.requestId) return;
      state.loading = false;
    });

    // get company
    builder.addCase(getCompany.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCompany.fulfilled, (state, action) => {
      state.company = normalizeCompanyVerification(action?.payload?.response);
      state.loading = false;
    });
    builder.addCase(getCompany.rejected, (state) => {
      state.loading = false;
    });

    // get single company
    builder.addCase(getSingleCompany.pending, (state) => {
      state.singleCompanyLoading = true;
    });
    builder.addCase(getSingleCompany.fulfilled, (state, action) => {
      state.singleCompany = normalizeCompanyVerification(action?.payload?.response ?? action?.payload);
      state.singleCompanyLoading = false;
    });
    builder.addCase(getSingleCompany.rejected, (state) => {
      state.singleCompanyLoading = false;
    });

    // post company
    builder.addCase(postCompany.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(postCompany.fulfilled, (state, action) => {
      state.company = normalizeCompanyVerification(action?.payload?.response);
      //  debugger
      saveToken(action?.payload?.response?.token);
      state.uploading = false;
    });
    builder.addCase(postCompany.rejected, (state) => {
      state.uploading = false;
    });

    // update company
    builder.addCase(updateCompany.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateCompany.fulfilled, (state, action) => {
      state.company = normalizeCompanyVerification(action?.payload?.response);
      state.uploading = false;
    });
    builder.addCase(updateCompany.rejected, (state) => {
      state.uploading = false;
    });

    // post company logo
    builder.addCase(postCompanyLogo.pending, (state) => {
      state.logoLoading = true;
    });
    builder.addCase(postCompanyLogo.fulfilled, (state, action) => {
      state.companyLogo = action?.payload?.response;
      state.logoLoading = false;
    });
    builder.addCase(postCompanyLogo.rejected, (state) => {
      state.logoLoading = false;
    });

    // delete company logo
    builder.addCase(deleteCompanyLogo.pending, (state) => {
      state.logoLoading = true;
    });
    builder.addCase(deleteCompanyLogo.fulfilled, (state, action) => {
      state.companyLogo = {};
      state.logoLoading = false;
    });
    builder.addCase(deleteCompanyLogo.rejected, (state) => {
      state.logoLoading = false;
    });

    // delete company
    builder.addCase(deleteCompany.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteCompany.fulfilled, (state, action) => {
      state.company = normalizeCompanyVerification(action?.payload?.response);
      state.loading = false;
    });
    builder.addCase(deleteCompany.rejected, (state) => {
      state.loading = false;
    });

    // brand

    // get all Brand
    builder.addCase(getAllBrands.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllBrands.fulfilled, (state, action) => {
      state.brands = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(getAllBrands.rejected, (state) => {
      state.loading = false;
    });

    // get Brand
    builder.addCase(getBrand.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBrand.fulfilled, (state, action) => {
      state.brand = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(getBrand.rejected, (state) => {
      state.loading = false;
    });

    // post Brand
    builder.addCase(postBrand.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(postBrand.fulfilled, (state, action) => {
      // state.brand = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(postBrand.rejected, (state) => {
      state.uploading = false;
    });

    // update Brand
    builder.addCase(updateBrand.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateBrand.fulfilled, (state, action) => {
      // state.brand = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(updateBrand.rejected, (state) => {
      state.uploading = false;
    });

    // post Brand logo
    builder.addCase(postBrandLogo.pending, (state) => {
      state.logoLoading = true;
    });
    builder.addCase(postBrandLogo.fulfilled, (state, action) => {
      state.brandLogo = action?.payload?.response;
      state.logoLoading = false;
    });
    builder.addCase(postBrandLogo.rejected, (state) => {
      state.logoLoading = false;
    });

    // delete Brand logo
    builder.addCase(deleteBrandLogo.pending, (state) => {
      state.logoLoading = true;
    });
    builder.addCase(deleteBrandLogo.fulfilled, (state, action) => {
      state.brandLogo = {};
      state.logoLoading = false;
    });
    builder.addCase(deleteBrandLogo.rejected, (state) => {
      state.logoLoading = false;
    });

    // update status
    builder.addCase(updateCompanyStatus.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateCompanyStatus.fulfilled, (state, action) => {
      // state.brand = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(updateCompanyStatus.rejected, (state) => {
      state.uploading = false;
    });

    // verify
    builder.addCase(verifyCompany.pending, (state) => {
      state.verifing = true;
    });
    builder.addCase(verifyCompany.fulfilled, (state, action) => {
      // state.brand = action?.payload?.response;
      state.verifing = false;
    });
    builder.addCase(verifyCompany.rejected, (state) => {
      state.verifing = false;
    });

    // ship rocket
    builder.addCase(updateCompanyShiprocketTag.pending, (state) => {
      state.shiptagLoading = true;
    });
    builder.addCase(updateCompanyShiprocketTag.fulfilled, (state, action) => {
      // state.brand = action?.payload?.response;
      state.shiptagLoading = false;
    });
    builder.addCase(updateCompanyShiprocketTag.rejected, (state) => {
      state.shiptagLoading = false;
    });

    // update brand status
    builder.addCase(updateBrandStatus.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateBrandStatus.fulfilled, (state, action) => {
      // state.brand = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(updateBrandStatus.rejected, (state) => {
      state.uploading = false;
    });

    // delete brand
    builder.addCase(deleteBrand.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(deleteBrand.fulfilled, (state, action) => {
      state.brand = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(deleteBrand.rejected, (state) => {
      state.uploading = false;
    });
  },
});

export const { setEditBrand, setStepper, setBrandNull, setSingleCompanyNull } =
  companyAndBrandSlice.actions;
export default companyAndBrandSlice.reducer;
